<template>
  <div v-if="categories.length > 0" class="slider-wrapper">
    <div class="slider">
      <img class="slider-item" @click="selectCate(item)" :key="index" v-for="(item, index) in categoriesList" :src="item.src" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    handleSelectCategory: {
      type: Function,
      dafault: () => {}
    }
  },
  mounted () {
    if (this.selectCategorieUid.length === 0) {
      this.setSelectCategorieUid(this.categories[0].uid)
      this.setSelectCategorieName(this.categories[0].name)
    }
  },
  computed: {
    ...mapGetters({
      selectCategorieUid: 'home/selectCategorieUid'
    }),
    categoriesList () {
      return this.categories.map(item => {
        item.src =
          item.type === 'STORE' ? (this.selectCategorieUid.indexOf(item.uid) > -1 ? item.checkedIcon : item.unCheckedIcon) : item.icon
        return item
      })
    }
  },
  methods: {
    ...mapMutations({
      setSelectCategorieUid: 'home/setSelectCategorieUid',
      setSelectCategorieName: 'home/setSelectCategorieName',
      removeSelectCategorieUid: 'home/setSelectCategorieUid'
    }),
    selectCate (item) {
      console.log('selectCate', item)
      if (item.type === 'lINK') {
        window.open(item.link)
        return
      }
      this.setSelectCategorieUid(item.uid)
      this.setSelectCategorieName(item.name)
      this.handleSelectCategory(this.selectCategorieUid)
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-wrapper {
  width: calc(100% - 1.06rem);
  height: 0.86rem;
  line-height: 0.86rem;
  position: fixed;
  top: 0.95rem;
  left: 1.06rem;
  z-index: 999;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  .slider {
    position: absolute;
    left: 0;
    top: 0;
    width: auto;
    height: 0.86rem;
    .slider-item {
      cursor: pointer;
      display: inline-block;
      width: auto;
      height: 0.86rem;
      margin-left: 0.1rem;
    }
  }
}
</style>
